export class ReduceableReducer {
    constructor(initialState) {
        this.actions = new Map();
        this.initialState = initialState;
    }
    reduce(state, action) {
        if (state == null) {
            return this.initialState;
        }
        if (action.slice != null) {
            const reduce = this.actions.get(action.type);
            if (reduce != null) {
                return reduce.call(action, state, action);
            }
        }
        return state;
    }
}
export class PersistentReduceableReducer extends ReduceableReducer {
    rehydrate(state, data, root, manager) {
        return data;
    }
    dehydrate(state, manager) {
        return state;
    }
}
